import { StyleSheet } from 'react-native';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { Spacing } from 'src/theme-v2/spacing';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const styles = StyleSheet.create({
  errorWrapper: {
    flexDirection: 'row',
    paddingHorizontal: 16,
    gap: Spacing.Tight,
  },
  iconError: {
    width: Spacing.Compact,
    height: Spacing.Compact,
    margin: Spacing.Condensed,
  },
  textError: {
    ...textLatoStyleDS.BodyRegularSm,
    color: ColorTypography.TextColorError,
    flexDirection: 'column',
    display: 'flex',
  },
});
